module.exports = __webpack_public_path__ + "img/mc.ec2ae8d1.svg";